import { Remove } from 'icon'

import BaseBtn from './BaseBtn'

const RemoveBtn = (props) => {
  const { disabled, onClick, loading, tag } = props

  return (
    <BaseBtn
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      tag={tag}
      icon={<Remove color="#3F3F3F" />}
      color={'#626262'}
      bg_color={'#CCCCCC'}
      border_color={'#CCCCCC'}
    />
  )
}

export default RemoveBtn
